import './global.css';
import { useState, useEffect } from 'react';
import Sidebar from './components/sidebar';
import LayerBar from './components/layerbar';
import Header from './components/header';
import Canvas from './components/Canvas';
import { useContext } from "react";
import { UserContext } from "./providers/UserContext";

export default function App() {
  const [image, setImage] = useState(null);
  const { activeTool } = useContext(UserContext);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (activeTool === "removebg" || activeTool === "select" || activeTool === "text") {
      const handleMouseMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
      window.addEventListener("mousemove", handleMouseMove);
      return () => window.removeEventListener("mousemove", handleMouseMove);
    }
  }, [activeTool]);

  const removeBgCursor = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#8e8e8e" width="24" height="24">
      <path d="M2.47 16.47c-.293.293-.293.767 0 1.06.293.293.767.293 1.06 0l14-14c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-14 14Z"/>
      <path d="M2.47 9.53c-.293-.293-.293-.767 0-1.06l6-6c.293-.293.767-.293 1.06 0 .293.293.293.767 0 1.06l-6 6c-.293.293-.767.293-1.06 0Z"/>
      <path d="M2.47 5.53c-.293-.293-.293-.767 0-1.06l2-2c.293-.293.767-.293 1.06 0 .293.293.293.767 0 1.06l-2 2c-.293.293-.767.293-1.06 0Z"/>
      <path d="M10.47 16.47c-.293.293-.293.767 0 1.06.293.293.767.293 1.06 0l6-6c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-6 6Z"/>
      <path d="M6.47 17.53c-.293-.293-.293-.767 0-1.06l10-10c.293-.293.767-.293 1.06 0 .293.293.293.767 0 1.06l-10 10c-.293.293-.767.293-1.06 0Z"/>
      <path d="M2.47 12.47c-.293.293-.293.767 0 1.06.293.293.767.293 1.06 0l10-10c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-10 10Z"/>
      <path d="M14.47 17.53c-.293-.293-.293-.767 0-1.06l2-2c.293-.293.767-.293 1.06 0 .293.293.293.767 0 1.06l-2 2c-.293.293-.767.293-1.06 0Z"/>
    </svg>
  );

  const selectCursor = (
    <svg style={{width: "35px"}} fill="#8e8e8e" viewBox="0 0 20 20"><path d="M10.5 3.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5Z"></path><path d="M14.28 6.28a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 0 0 1.06 1.06l1-1Z"></path><path d="M7.28 13.28a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 1 0 1.06 1.06l1-1Z"></path><path d="M7 9.75a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5a.75.75 0 0 1 .75.75Z"></path><path d="M5.97 7.03a.75.75 0 0 0 1.06-1.06l-1.75-1.75a.75.75 0 0 0-1.06 1.06l1.75 1.75Z"></path><path fill-rule="evenodd" d="M8.22 8.22a.75.75 0 0 1 .767-.181l7.5 2.5a.75.75 0 0 1 .293 1.241l-1.97 1.97 1.97 1.97a.75.75 0 1 1-1.06 1.06l-1.97-1.97-1.97 1.97a.75.75 0 0 1-1.241-.293l-2.5-7.5a.75.75 0 0 1 .18-.767Zm4.998 5.001.002-.001.001-.002 1.64-1.64-4.925-1.642 1.642 4.926 1.64-1.64Z"></path><path d="M10.5 3.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5Z"></path><path d="M14.28 6.28a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 0 0 1.06 1.06l1-1Z"></path><path d="M7.28 13.28a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 1 0 1.06 1.06l1-1Z"></path><path d="M7 9.75a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5a.75.75 0 0 1 .75.75Z"></path><path d="M5.97 7.03a.75.75 0 0 0 1.06-1.06l-1.75-1.75a.75.75 0 0 0-1.06 1.06l1.75 1.75Z"></path><path fill-rule="evenodd" d="M8.22 8.22a.75.75 0 0 1 .767-.181l7.5 2.5a.75.75 0 0 1 .293 1.241l-1.97 1.97 1.97 1.97a.75.75 0 1 1-1.06 1.06l-1.97-1.97-1.97 1.97a.75.75 0 0 1-1.241-.293l-2.5-7.5a.75.75 0 0 1 .18-.767Zm4.998 5.001.002-.001.001-.002 1.64-1.64-4.925-1.642 1.642 4.926 1.64-1.64Z"></path></svg>
  );

  const textCursor = (
    <svg style={{width: "35px"}} fill="#8e8e8e" viewBox="0 0 20 20"><path d="M4 4.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-.75h-3.5v8.75h1.25a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.25v-8.75h-3.5v.75a.75.75 0 0 1-1.5 0v-1.5Z"></path></svg>
  );

  return (
    <>
      <Header onLoad={setImage} />
      <div className="flex bg-[#252525] relative">
        <Sidebar />
        <div className="flex-1 flex flex-col items-center justify-center p-4 bg-[#252525] relative"
        style={{
          cursor: activeTool && activeTool !== false ? "none" : "auto" // ẩn con trỏ chuột khi dùng removebg
        }}
        >
          {image && <Canvas image={image} />}

          {activeTool === "removebg" ?
            <div
              style={{
                position: "fixed",
                left: mousePos.x,
                top: mousePos.y,
                pointerEvents: "none",
                transform: "translate(-12px, -12px)", // đặt tâm SVG trùng con trỏ
                zIndex: 9999,
              }}
            >
              {removeBgCursor}
            </div>
          : activeTool === "select" ? <div
              style={{
                position: "fixed",
                left: mousePos.x,
                top: mousePos.y,
                pointerEvents: "none",
                transform: "translate(-12px, -12px)", // đặt tâm SVG trùng con trỏ
                zIndex: 9999,
              }}
            >
              {selectCursor}
            </div> : activeTool === "text" ? <div
              style={{
                position: "fixed",
                left: mousePos.x,
                top: mousePos.y,
                pointerEvents: "none",
                transform: "translate(-12px, -12px)", // đặt tâm SVG trùng con trỏ
                zIndex: 9999,
              }}
            >
              {textCursor}
            </div> : null }
        </div>
        <LayerBar image={image} />
      </div>
    </>
  );
}
